<template>
  <div class="pages">
    <v-touch class="v-touch">
      <div class="index-content" :class="$i18n.locale">
        <!-- 
        
        <div class="item-txt" v-html="$t1(confirm, 'confirm')"></div> -->
        <!-- <div class="item-txt">您的信息已收到，会议正在筹备中，敬请期待！</div>
        <div class="item-txt">读懂中国即将开启<span>2022年读懂中国国际会议</span>，大会时间为
          <span>12月1日至12月4日</span>，为期5天。本届会议将以“<span>从哪里来，到哪里去——世界百年变局与中国和中国共产党</span>"
          为主题，讲好中国与中国共产党的故事，设置了<span>开幕式及主旨演讲、6场专题论坛、12场平行研讨会和多种配套活动</span>。
        </div>
        <div class="item-txt"> 期待您的到来！</div> -->
        <!-- <div class="button" @click="$router.push('personal')">
          {{ $t3("查看个人信息", "View profile") }}
        </div> -->
        <div class="content-box">
          <div class="content-inner-box">
            <div class="content-information">
              <img class="logo" src="@/assets/img/auditLogo.png" />
              <span class="audit_tip">{{$t3('审核中','in review')}}</span>
              <div class="title">
                {{ $t3("尊敬的", "Distinguished") }}{{
          {
            MT: $t3('媒体记者', ' media'),
            WK: $t3('工作人员', ' worker'),
            GZ: $t3('嘉宾', ' guest')
          }[$route.params.type] }}
              </div>
              <div v-if="$route.params.type !== 'GZ'" class="message" v-html="$t1(confirm, 'confirm')"></div>
              <div v-else class="message">
                <p>您已完成报名，主办方通过申请后将及时通知您！</p>
                <p>温馨提示：基本信息、联系信息部分一经提交不得修改。如有问题，请与工作人员联系。</p>
                <p>衷心感谢您报名参会，在这里我们与世界一起“读懂中国”。</p>
              </div>
              <!-- <div class="message">
                读懂中国即将开启2022年读懂中国国际会议，大会时间为12月1日至12月4日，
                为期 5 天。本届会议将以“从哪里来，到哪里去——世界百年变局与中国和中国
                共产党”为主题，讲好中国与中国共产党的故事，设置了开幕式及主旨演讲、6
                场专题论坛、12场平行研讨会和多种配套活动。
              </div> -->
              <!-- <div class="button" @click="$router.push('media')">
                {{ $t3("查看个人信息", "Go back and review") }}
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </v-touch>
  </div>
</template>

<script>
import { getMediaConfirm } from "@/api/conference";
import { getConferenceInfo } from "@/api/conference";
import { toMedia } from "@/utils/request";
import { mapGetters } from "vuex";

export default {
  name: "infoComplete",
  data() {
    return {
      confirm: {},
      swipe: false,
      conferenceInfo: {},
      homeContent: [
        {
          ImgSrc: require("@/assets/img/homePageImg01.png"),
          label: "briefInfo",
          path: "conferenceIntro",
        },
        {
          ImgSrc: require("@/assets/img/homePageImg02.png"),
          label: "distribution",
          path: "distribution",
        },
        {
          ImgSrc: require("@/assets/img/homePageImg03.png"),
          label: "agenda",
          path: "agenda",
        },
        {
          ImgSrc: require("@/assets/img/homePageImg04.png"),
          label: "promise",
          path: "health",
        },
        {
          ImgSrc: require("@/assets/img/homePageImg05.png"),
          label: "personalInfo",
          path: "personal",
        },
        {
          ImgSrc: require("@/assets/img/homePageImg06.png"),
          label: "website",
          path: "",
        },
        {
          ImgSrc: require("@/assets/img/homePageImg07.png"),
          label: "video",
          path: "",
        },
        {
          ImgSrc: require("@/assets/img/homePageImg08.png"),
          label: "album",
          path: "",
        },
        {
          ImgSrc: require("@/assets/img/homePageImg09.png"),
          label: "partner",
          path: "cooperation",
        },
      ],
      language: false,
    };
  },
  computed: {
    ...mapGetters(['status', "type", "needUpdateInfo"]),
  },
  mounted() {
    if (this.status === 'ENABLE') {
      this.$router.push('mediaSuccess')
    } else {
      this.getMediaConfirm();
      this.getConferenceInfo();
    }
  },
  methods: {
    getMediaConfirm() {
      getMediaConfirm({ conferenceId: this.$route.params.conferenceId }).then(
        (res) => {
          this.confirm = res.data;
        }
      );
    },
    toMedia,
    go(item) {
      if (item.path && item.path !== "") {
        this.$router.push(item.path);
      } else if (item.link && item.link !== "") {
        window.open(
          item.link.indexOf("http") === 0 ? item.link : "https://" + item.link
        );
      }
    },
    getConferenceInfo() {
      getConferenceInfo({ conferenceId: this.$route.params.conferenceId }).then(
        (res) => {
          this.conferenceInfo = res.data;
          this.$set(this.homeContent[5], "link", res.data.homeLink);
          this.$set(this.homeContent[6], "link", res.data.liveLink);
          this.$set(this.homeContent[7], "link", res.data.photoLink);
        }
      );
    },
    langChange() {
      this.language = !this.language;
      console.log(this.language);
      if (this.language) {
        localStorage.setItem("lang", "en");
        this.$i18n.locale = "en";
      } else {
        localStorage.setItem("lang", "zh");
        this.$i18n.locale = "zh";
      }
      // window.location.reload() //页面刷新
    },
  },
};
</script>

<style lang="scss" scoped>
.v-touch {
  z-index: 1;
  touch-action: pan-y !important; //解决页面垂直滚动失效问题
}

.index-content {
  position: relative;
  width: 100%;
  min-height: 100vh;
  padding: 35px 12px 51px;
  background: url("~@/assets/img/homePageBG.png") top left no-repeat;
  background-size: cover;
  box-sizing: border-box;
  text-align: left;

  &.en {
    .title,
    .tip,
    .message {
      font-family: "Times New Roman";
    }
  }
  .content-box {
    position: relative;
    width: 100%;
    padding: 0 8px 10px;
    border-radius: 4px;
    background: rgba($color: #fff, $alpha: 0.15);
    box-sizing: border-box;
    &::before {
      content: "";
      position: absolute;
      top: -15px;
      left: 50%;
      transform: translateX(-50%);
      width: 375px;
      height: 56px;
      background: url(~@/assets/img/scroll_top.png) top center no-repeat;
      background-size: cover;
    }
    .content-inner-box {
      width: 100%;
      padding: 14px 7px 8px;
      background: #e9ecff;
      border-radius: 4px;
      box-sizing: border-box;
      .content-information {
        width: 100%;
        min-height: calc(100vh - 118px);
        height: auto;
        padding: 30px 20px 66px;
        background: url(~@/assets/img/scroll_bg.png) no-repeat;
        background-size: 100% 100%;
        box-sizing: border-box;
        .logo {
          display: block;
          width: 64px;
          height: 64px;
          margin: 0 auto;
          object-fit: contain;
        }
        .audit_tip {
          height: 24px;
          font-size: 16px;
          font-family: SourceHanSansSC-Medium, SourceHanSansSC;
          font-weight: 500;
          color: #383C41;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 10px;
        }
        .title {
          margin: 20px 0 0;
          font-size: 32px;
          color: #003f8f;
          line-height: 39px;
          font-family: "SimHei", "Microsoft YaHei", "PingFang SC", "Helvetica Neue", Helvetica, Arial, sans-serif; // AaJianHaoTi;
          text-align: center;
          white-space: nowrap;
        }
        .tip {
          margin: 20px 0 0;
          font-size: 17px;
          font-weight: 500;
          color: #003f8f;
          line-height: 26px;
        }
        .message {
          margin: 10px 0 0;
          font-size: 14px;
          font-weight: 400;
          color: #003f8f;
          line-height: 26px;
          ::v-deep(p span) {
            text-wrap: wrap!important;
          }
        }
        .button {
          min-width: 160px;
          height: 44px;
          margin: 73px auto 0;
          background: url(~@/assets/img/scroll_button.png) center no-repeat;
          background-size: 100% 100%;
          font-size: 14px;
          font-weight: 500;
          color: #ffffff;
          line-height: 44px;
          text-align: center;
        }
      }
    }
  }
}

// 过渡动画
.swipe-left {
  transition: all 0.5s;
  transform: translateX(-100%);
}

// 首页css
.index-content-home {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 64px 0 0;
  background: url("~@/assets/img/homeBg.png") top left no-repeat;
  background-size: cover;
  box-sizing: border-box;
  overflow-y: auto;
}

img {
  display: block;
  margin: 0 auto;
  width: 330px;
  height: auto;
  object-fit: contain;
}

.language {
  position: absolute;
  top: 20px;
  right: 15px;
  font-size: 12px;
  font-weight: 400;
  color: #fff;
  line-height: 17px;

  span {
    opacity: 0.5;
  }
}

.homePage-content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative;
  margin: 40px 0;
  padding: 0 25px;
  width: 100%;
  box-sizing: border-box;

  .context-box {
    position: relative;
    display: flex;
    width: 100px;
    height: 94px;
    margin: 0 0 12px;
    background: url("~@/assets/img/homePage_contentBG.png") center no-repeat;
    background-size: contain;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      display: block;
      width: 45px;
      height: 45px;
      margin: 0 0 2px;
      object-fit: contain;
    }

    font-size: 12px;
    font-weight: 400;
    color: #fff;
    line-height: 17px;
  }
}
</style>
